module.exports = __webpack_public_path__ + "media/images/360/sleep_paralysis_night_mare-698d838fa2899adf716307054c539a9a.webp";